import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ActivityBuilder } from '../../models/builders/activity.builder';
import { Activity } from '../../models/activity';
import { ActivityTypeBuilder } from '../../models/builders/activity-type.builder';

const activityBody = (activity: Activity) => ({
  name: activity.name,
  type: activity.type,
  viewType: activity.viewType,
});

@Injectable()
export class ActivityApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }activities`;
  }

  createActivity(activity) {
    return this.httpClient.post(this.apiUrl, activityBody(activity)).pipe(map(ActivityBuilder.fromJson));
  }

  deleteActivity(activity: Activity) {
    return this.httpClient.delete(`${ this.apiUrl }/${ activity.hash }`);
  }

  getActivities() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ActivityBuilder.fromList));
  }

  getActivity(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ActivityBuilder.fromJson)
      );
  }

  getActivityTypes() {
    return this.httpClient.get(`${ this.apiUrl }/types`)
      .pipe(
        map(ActivityTypeBuilder.fromList)
      );
  }

  getActivityViewTypes() {
    return this.httpClient.get(`${ this.apiUrl }/view-types`)
      .pipe(
        map(ActivityTypeBuilder.fromList)
      );
  }

  updateActivity(activity: Activity) {
    return this.httpClient.put(`${ this.apiUrl }/${ activity.hash }`, activityBody(activity));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/activity-api.service.ts